<form [formGroup]="inlineNoteEditorForm" class="c-inline-note-editor">
  <div
    class="form-group"
    [class.has-error]="noteControl.dirty && noteControl.errors"
  >
    <label class="form-label" [for]="noteEditorId" [ngSwitch]="noteType">
      <ng-container *ngSwitchCase="InlineNoteEditorType.FOR_LIBRARY">
        <i
          class="fal fa-fw fa-university fa-lg qa-library-note"
          aria-hidden="true"
        ></i>
        <ng-container i18n="@@inlineNoteEditor-label-noteForLibrary"
          >Note for library</ng-container
        >
        <span class="field-required">(Required)</span>
      </ng-container>
      <ng-container *ngSwitchCase="InlineNoteEditorType.FOR_STUDENTS">
        <i
          class="fal fa-fw fa-graduation-cap fa-lg qa-student-note"
          aria-hidden="true"
        ></i>
        <ng-container i18n="@@inlineNoteEditor-label-noteForStudents"
          >Note for students</ng-container
        >
        <span class="field-required">(Required)</span>
      </ng-container>
      <ng-container *ngSwitchCase="InlineNoteEditorType.PERSONAL">
        <i
          class="fal fa-fw fa-lock fa-lg qa-personal-note"
          aria-hidden="true"
        ></i>
        <ng-container i18n="@@inlineNoteEditor-label-personalNote"
          >Personal note</ng-container
        >
        <span class="field-required">(Required)</span>
      </ng-container>
      <span class="field-hint" i18n="@@inlineNoteEditor-label-note-hint">
        Maximum {{ noteMaxLength }} characters</span
      >
    </label>

    <textarea
      rlAutosize
      [attr.aria-describedby]="
        noteControl.dirty && noteControl.errors ? errorMessageId : null
      "
      [attr.aria-invalid]="
        noteControl.dirty && noteControl.errors ? true : false
      "
      [id]="noteEditorId"
      formControlName="note"
      rlAutofocus
      class="form-control c-inline-note-editor__note"
      name="note"
      required
    >
    </textarea>

    <div
      *ngIf="noteControl.dirty && noteControl.errors ? true : false"
      [id]="errorMessageId"
      [ngSwitch]="noteType"
      class="field-error"
      role="alert"
    >
      <span *ngIf="noteControl.errors.required" class="qa-note-error--required">
        <ng-container
          *ngSwitchCase="InlineNoteEditorType.FOR_LIBRARY"
          i18n="@@inlineNoteEditor-note-noteForLibraryRequired"
        >
          Note for library is a required field
        </ng-container>
        <ng-container
          *ngSwitchCase="InlineNoteEditorType.FOR_STUDENTS"
          i18n="@@inlineNoteEditor-note-noteForStudentsRequired"
        >
          Note for students is a required field
        </ng-container>
      </span>
      <span
        *ngIf="noteControl.errors.maxlength"
        class="qa-note-error--maxlength"
      >
        <ng-container
          *ngSwitchCase="InlineNoteEditorType.FOR_LIBRARY"
          i18n="@@inlineNoteEditor-note-noteForLibraryLength"
        >
          Note for library length must be less than or equal to
          {{ noteMaxLength }} characters
        </ng-container>
        <ng-container
          *ngSwitchCase="InlineNoteEditorType.FOR_STUDENTS"
          i18n="@@inlineNoteEditor-note-noteForStudentsLength"
        >
          Note for students length must be less than or equal to
          {{ noteMaxLength }} characters
        </ng-container>
      </span>
      <span *ngIf="noteControl.errors.pattern" class="qa-note-error--blank">
        <ng-container
          *ngSwitchCase="InlineNoteEditorType.FOR_LIBRARY"
          i18n="@@inlineNoteEditor-note-noteForLibraryBlank"
        >
          Note for library cannot be blank
        </ng-container>
        <ng-container
          *ngSwitchCase="InlineNoteEditorType.FOR_STUDENTS"
          i18n="@@inlineNoteEditor-note-noteForStudentsBlank"
        >
          Note for students cannot be blank
        </ng-container>
      </span>
    </div>
  </div>
  <div class="c-inline-note-editor__controls c-inline-editor-buttons">
    <button
      type="button"
      class="btn btn-primary qa-save"
      i18n="@@inlineNoteEditor-btn-save"
      [disabled]="!inlineNoteEditorForm.valid"
      (click)="onSubmit()"
    >
      Save
    </button>

    <button
      class="btn btn-default qa-cancel"
      type="button"
      i18n="@@inlineNoteEditor-btn-cancel"
      (click)="onCancel()"
    >
      Cancel
    </button>

    <button
      class="btn btn-danger qa-delete"
      type="button"
      i18n="@@inlineNoteEditor-btn-delete"
      (click)="onDelete()"
    >
      Delete
    </button>
  </div>
</form>
